module.exports = __webpack_public_path__ + "img/长椅.6e8162e5.png";